module.exports = __webpack_public_path__ + "static/img/02_goetze_cornelius_carstens.e8e3182.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/goetze/02_goetze_cornelius_carstens.jpg
// module id = ugTB
// module chunks = 1